import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([_ctx.variant === 'icon' ? 'a-arrow-link': 'a-button', _ctx.classes]),
    disabled: _ctx.isDisabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      (_ctx.content)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString(_ctx.content), 1))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}